import React, { useEffect, useState, useRef } from 'react'
import { externalDataFetch } from '../../Utils/APIs/externalDataFetchAPI';
import { insertData } from '../../Utils/APIs/commonInsertAPI';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine";

import { trackFieldPersonApi } from '../../Utils/APIs/trackAPI';
import { trackEmployeeApi } from '../../Utils/APIs/tackEmployeeAPI';
import { showAllWarehousesApi } from '../../Utils/APIs/allWarehouseAPI';
import axios from 'axios';
import DailyPunchList from './DailyPunchList';
import VehicleIndex from './Vehicle/Index';
import PaymentRequest from '../Payment/PaymentRequest';
import { showData } from '../../Utils/APIs/commonShowAPI';

// ✅ Routing component that supports multiple waypoints
const RoutingMachine = ({ waypoints }) => {
  const map = useMap();
  const routingControlRef = useRef(null); // Store routing control reference

  useEffect(() => {
    if (!map || waypoints.length < 2) return;

    // Remove existing routing control before creating a new one
    if (routingControlRef.current) {
      try {
        map.removeControl(routingControlRef.current);
      } catch (error) {
        console.warn("Error removing routing control:", error);
      }
    }

    // Create a new routing control
    const routingControl = L.Routing.control({
      waypoints: waypoints.map(([lat, lng]) => L.latLng(lat, lng)),
      routeWhileDragging: true,
      addWaypoints: false,
      itinerary: true,
      // show:false,
      showAlternatives: false,
      createMarker: () => null,
      fitSelectedRoutes: true,
      lineOptions: { styles: [{ color: "blue", weight: 4, opacity: 0.7 }] },
      serviceUrl: "https://router.project-osrm.org/route/v1", // ⚠️ OSRM public server
    }).addTo(map);

    routingControlRef.current = routingControl;
    
  }, [map, waypoints]);

  return null;
};

const Index = () => {
  const startIcon = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/128/684/684933.png", // Green start icon
    iconSize: [45, 45], // Size of the icon
  });
  
  const endIcon = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/128/684/684913.png", // Red end icon
    iconSize: [45, 45], // Size of the icon
  });
  
  const defaultIcon = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/128/684/684908.png", // Default blue marker
    iconSize: [26, 26],
  });

  const [coordinates, setCoordinates] = useState([]);
  const [halt, setHalt] = useState([]);;
  // const [empToggle, setEmpToggle] = useState(true);
  const [dropdownToggle, setDropdownToggle] = useState(false);
  const [fieldEmpList, setFieldEmpList] = useState([]);
  const [selectedEmpList, setSelectedEmpList] = useState([]);
  const [trackResponse, setTrackResponse] = useState(null);
  const [ resendResponse, setResendResponse ] = useState([]);
  const [ showAllWarehouses, setShowAllWarehouses ] = useState([]); 
  const [ showTrackList, setShowTrackList ] = useState(true);
  const [ showAttendenceList, setShowAttendenceList ] = useState(false);
  const [ fieldPersonAttendenceList, setFieldPersonAttendenceList ] = useState([]);

  const [FieldPersonData, setFieldPersonData] = useState([]);


  const attendenceListApi = async() => {
    try {
      const sendRequest = await axios.get(`${process.env.REACT_APP_API_URL}/track/dailyPunchList`)
      setFieldPersonAttendenceList(sendRequest.data.data);
    } catch (error) {
      alert('Something went wrong contact to shiv');
    }
  }

  useEffect(() => {
    trackFieldPersonApi(setFieldPersonData);
    attendenceListApi();
  }, []);

  // new changes
  const [fieldEmpToggle, setFieldEmpToggle] = useState(false);
  const [vehicleToggle, setVehicleToggle] = useState(false);
  const [mapToggle, setMapToggle] = useState(false);
  const [paymentRequestToggle, setPaymentRequestToggle] = useState(false);

  const fieldEmpCheckedHandle =() =>{
    setFieldEmpToggle(true);
    setVehicleToggle(false);
    setPaymentRequestToggle(false);
    setMapToggle(false);
  }

  const vehicleCheckedHandle =() =>{
    setFieldEmpToggle(false);
    setVehicleToggle(true);
    setPaymentRequestToggle(false);
    setMapToggle(false);
  }

  const mapCheckedHandle =() =>{
    setFieldEmpToggle(false);
    setVehicleToggle(false);
    setPaymentRequestToggle(false);
    setMapToggle(true);
  }

  const paymentCheckedHandle = () =>{
    setPaymentRequestToggle(true); 
    setFieldEmpToggle(false);
    setVehicleToggle(false);
    setMapToggle(false);
  }



  // by Shiv
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const [selectedEmpName, setSelectedEmpName] = useState(null);
  const handleSingleSelection = (id, name) => {
    setSelectedEmpId(id);
    setSelectedEmpName(name);
    setDropdownToggle(false); // Close dropdown after selection
  };

  useEffect(()=>{
    showData("/external/fieldEmployeeList", setFieldEmpList);
    showAllWarehousesApi(setShowAllWarehouses);
  }, []);

  const handleTrack = async()=> {
    if(selectedEmpId === null){
      alert("Please Select field Employee");
      setDropdownToggle(!dropdownToggle);
      return;
    }
    await insertData("track/trackFieldEmp", setTrackResponse, {empId:selectedEmpId});
    setSelectedEmpId(null);
    setSelectedEmpName(null);
    if(trackResponse){
      alert(trackResponse || "Track Successfully");
    }else{
      alert("Track Successfully");
    }
    setTrackResponse([]);
  }

  const handleResend = async() => {
    if(selectedEmpId === null){
      alert("Please Select field Employee");
      setDropdownToggle(!dropdownToggle);
      return;
    }
    await insertData("track/resendTrackingSMS_Call", setResendResponse, {empId:selectedEmpId});
    setSelectedEmpId(null);
    setSelectedEmpName(null);
    if(resendResponse){
      alert(resendResponse || "Resend Successfully");
    }else{
      alert("Resend Successfully");
    }
    setResendResponse([]);
  }
    useEffect(() =>{
      if(coordinates?.length > 0 ) mapCheckedHandle()
    },[coordinates])
  const handleUntrack = async() => {
    if(!selectedEmpId){
      alert("Please Select field Employee");
      return;
    }else{
      await insertData("track/untrackFieldEmp", setResendResponse, {empId: selectedEmpId});
      setSelectedEmpId(null);
      setSelectedEmpName(null);
      if (resendResponse) {
        alert(resendResponse || "Untrack Successfully");
      } else {
        alert("Untrack Successfully");
      }
    }
    // work on 
    setSelectedEmpList([]);
  }
  const [lossDate, setLossDate] = useState('');
  const findLatLong = async() => {
    if(!lossDate){
      alert("Please Select Date");
      return;
    }
    if(selectedEmpId === null){
      alert("Please Select field Employee");
      setDropdownToggle(!dropdownToggle);
      return;
    }
    const data = {
      fieldEmpId: selectedEmpId,
      punchDate: lossDate
    }
    try {
        const sendRequest = await axios.post(`${process.env.REACT_APP_API_URL}/track/findTravelHistory`, data);
        if(sendRequest.data.data === null){
            setCoordinates([]);
            alert('No to Data to show');
            return false;
        }
        setCoordinates(sendRequest.data?.data?.gioLocList);
        setHalt(sendRequest.data?.data?.halt);
        return true;
    } catch (error) {
        setCoordinates([]);
        alert('No Data to show');
        return false;
    }
  }
  return (
    <>
      <div className="flex flex-col h-full w-full pl-8">
        <div className=" flex items-center justify-center">
          <ul className="items-center text-sm font-medium text-gray-900 bg-white  rounded-lg sm:flex">
            <li>
              <div className="flex items-center ps-3">
                <input
                  id="horizontal-list-radio-license"
                  type="radio"
                  value={fieldEmpToggle}
                  checked={fieldEmpToggle === true}
                  onChange={fieldEmpCheckedHandle}
                  name="list-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  for="horizontal-list-radio-license"
                  className="w-full py-3 ms-2 text-sm font-medium text-gray-900"
                >
                  Field Employee{" "}
                </label>
              </div>
            </li>
            <li>
              <div className="flex items-center ps-3">
                <input
                  id="horizontal-list-radio-id"
                  type="radio"
                  value={vehicleToggle}
                  checked={vehicleToggle === true}
                  onChange={vehicleCheckedHandle}
                  name="list-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  for="horizontal-list-radio-id"
                  className="w-full py-3 ms-2 text-sm font-medium text-gray-900 "
                >
                  Vehicle{" "}
                </label>
              </div>
            </li>
            <li>
              <div className="flex items-center ps-3">
                <input
                  id="horizontal-list-radio-military"
                  type="radio"
                  value={mapToggle}
                  checked={mapToggle === true}
                  onChange={mapCheckedHandle}
                  name="list-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  for="horizontal-list-radio-military"
                  className="w-full py-3 ms-2 text-sm font-medium text-gray-900 "
                >
                  Map
                </label>
              </div>
            </li>
            <li>
              <div className="flex items-center ps-3">
                <input
                  id="horizontal-list-radio-license1"
                  type="radio"
                  value={paymentRequestToggle}
                  checked={paymentRequestToggle === true}
                  onChange={paymentCheckedHandle}
                  name="list-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  for="horizontal-list-radio-license1"
                  className="w-full py-3 ms-2 text-sm font-medium text-gray-900 "
                >
                  Payment Request{" "}
                </label>
              </div>
            </li>
          </ul>
        </div>
        {fieldEmpToggle && (
          <div className='flex gap-12'>
            <div className="w-1/4">
              <label
                htmlFor="stage"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Field Employee List
              </label>
              <div className="relative">
                {/* Toggle Button */}
                <button
                  type="button"
                  className="relative py-3 ps-4 pe-9 flex gap-x-2 w-full bg-gray-50 border border-gray-200 rounded-sm text-start text-sm"
                  onClick={() => setDropdownToggle(!dropdownToggle)}
                >
                  {selectedEmpName ? selectedEmpName : "Select an employee..."}
                  <div className="absolute top-1/2 end-3 -translate-y-1/2">
                    <svg
                      className="shrink-0 size-3.5 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m7 15 5 5 5-5" />
                      <path d="m7 9 5-5 5 5" />
                    </svg>
                  </div>
                </button>

                {/* Dropdown */}
                {dropdownToggle && (
                  <div className="mt-2 z-50 w-full max-h-96 p-1 space-y-0.5 bg-white border border-gray-200 rounded-sm overflow-hidden overflow-y-auto">
                    {fieldEmpList.map(({ _id, name }) => (
                      <div
                        key={_id}
                        className={`flex items-center py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg ${
                          selectedEmpId && selectedEmpId === _id
                            ? "font-semibold bg-gray-100"
                            : ""
                        }`}
                        onClick={() => handleSingleSelection(_id, name)}
                      >
                        <div>{name}</div>
                        {selectedEmpId && selectedEmpId === _id && (
                          <div className="ms-auto">
                            <svg
                              className="shrink-0 size-4 text-blue-600"
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
                            </svg>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex justify-evenly">
                <button
                  className="bg-yellow-400 py-2 px-4 mt-4 rounded-sm hover:bg-yellow-500"
                  onClick={handleTrack}
                >
                  Track
                </button>

                {/* Future work for untrack and resend button */}
                <button
                  className="bg-red-400 py-2 px-4 mt-4 rounded-sm hover:bg-red-500"
                  onClick={handleUntrack}
                >
                  Untrack
                </button>
                <button
                  className="bg-green-400 py-2 px-4 mt-4 rounded-sm hover:bg-green-500"
                  onClick={handleResend}
                >
                  Resend
                </button>
              </div>

              <div className='flex justify-evenly'>
                <button
                    className="bg-gray-400 py-2 px-4 mt-4 rounded-sm hover:bg-gray-500"
                    onClick={() => {
                      if(!showTrackList){
                        setShowTrackList(!showTrackList);
                        setShowAttendenceList(!showAttendenceList)
                      }
                    }}
                  >
                    Track List
                </button>

                <button
                    className="bg-blue-400 py-2 px-4 mt-4 rounded-sm hover:bg-blue-500"
                    onClick={() => {
                      if(!showAttendenceList){
                        setShowTrackList(!showTrackList);
                        setShowAttendenceList(!showAttendenceList)
                      }
                    }}
                >
                    Attendence List
                </button>
              </div>
            </div>
            <div className='w-full overflow-auto h-[calc(100vh-8rem)]'>
              <div className=''>
                <table className=" w-full text-sm text-left rtl:text-right text-gray-50 pb-8">
                  { showTrackList && <thead className=" text-xs border border-gray-150  uppercase ">
                      <th scope="col" className="bg-gray-800 text-gray-100 sticky top-0 px-6 py-3 text-center font-semibold">Sr no.</th>
                      <th scope="col" className="bg-gray-800 text-gray-100 sticky top-0 px-6 py-3 text-center font-semibold">Status</th>
                      <th scope="col" className="bg-gray-800 text-gray-100 sticky top-0 px-6 py-3 text-center font-semibold">Name</th>
                      <th scope="col" className="bg-gray-800 text-gray-100 sticky top-0 px-6 py-3 text-center font-semibold">Contact</th>
                      <th scope="col" className="bg-gray-800 text-gray-100 sticky top-0 px-6 py-3 text-center font-semibold">latitude</th>
                      <th scope="col" className="bg-gray-800 text-gray-100 sticky top-0 px-6 py-3 text-center font-semibold">longitude</th>
                  </thead>}
                  { showAttendenceList && <DailyPunchList /> }
                      <tbody>
                      {
                        showTrackList && FieldPersonData?.map(({ _id, contact, name, status, latitude, longitude } , index) => (
                            <>
                                <tr className="bg-gray-50 border-b hover:bg-yellow-200 text-gray-900 h-8" key={_id} onClick={(e) => {trackEmployeeApi(_id, setCoordinates, setHalt, status).then((res) => {
                                    if(res){
                                      mapCheckedHandle();
                                    }else{
                                      alert('For more Info, Contact to Shiv Shankar');
                                    }
                                  })}}>
                                <th scope="row" className="px-2 font-medium text-center text-gray-900 whitespace-nowrap ">
                                    {index+1}
                                </th>
                                <th scope="row" className="px-2 text-center text-gray-900 whitespace-nowrap ">
                                    <button className={` ${(status === "ALLOWED") ? 'bg-green-400' : ''} ${(status === "PENDING") ? 'bg-red-400' : ''} ${status === 'Mobile Not Registered For Tracking' ? 'bg-gray-700' : ""} bg-black rounded-md px-2 text-white p-1 font-normal text-xs`}>{status === 'Mobile Not Registered For Tracking' ? 'Not Track' : status}</button>
                                </th>
                                <th scope="row" className="px-2 font-medium text-center text-gray-900 whitespace-nowrap ">
                                    {name}
                                </th>
                                <td className="px-2 text-center">
                                    {contact}
                                </td>
                                <td className="px-2 text-center">
                                    {latitude }
                                </td>
                                <td className="px-2 text-center text-black">
                                    {longitude}
                                </td>
                            </tr>
                            </>
                        ))
                      }
                                 
                      </tbody>
                  </table>
                </div>
              </div>
          </div>
        )}
        {vehicleToggle && <VehicleIndex coordinatesSetter={setCoordinates} />}

        {mapToggle && (
          <div className='flex flex-row gap-2'>
            <div className='flex flex-col'>
              <div className='flex flex-row gap-4 justify-center items-center '> 
                <div className="relative block">
                  {/* Toggle Button */}
                  <button
                    type="button"
                    className="relative py-3 ps-4 pe-9 flex gap-x-2 w-full bg-gray-50 border border-gray-200 rounded-sm text-start text-sm"
                    onClick={() => setDropdownToggle(!dropdownToggle)}
                  >
                    {selectedEmpName ? selectedEmpName : "Select an employee..."}
                    <div className="absolute top-1/2 end-3 -translate-y-1/2">
                      <svg
                        className="shrink-0 size-3.5 text-gray-500"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m7 15 5 5 5-5" />
                        <path d="m7 9 5-5 5 5" />
                      </svg>
                    </div>
                  </button>
                  {/* Dropdown */}
                  {dropdownToggle && (
                    <div className="mt-2 z-50 w-full max-h-96 p-1 space-y-0.5 bg-white border border-gray-200 rounded-sm overflow-hidden overflow-y-auto">
                      {fieldEmpList.map(({ _id, name }) => (
                        <div
                          key={_id}
                          className={`flex items-center py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg ${
                            selectedEmpId && selectedEmpId === _id
                              ? "font-semibold bg-gray-100"
                              : ""
                          }`}
                          onClick={() => handleSingleSelection(_id, name)}
                        >
                          <div>{name}</div>
                          {selectedEmpId && selectedEmpId === _id && (
                            <div className="ms-auto">
                              <svg
                                className="shrink-0 size-4 text-blue-600"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                              >
                                <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
                              </svg>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  </div>
                <input
                  type="date"
                  id="theftDate"
                  value={lossDate || ''}
                  onChange={(e) => {
                    setLossDate(e.target.value);
                  }}
                  className="bg-gray-50 border h-12 border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5"
                />
                <button 
                  type="button" 
                  className="text-white h-12 bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                  onClick={(e) => findLatLong()}
                >
                  Submit
                </button>
              </div>
              <div style={{ textAlign: "center", paddingTop: "10px", width: '65vw', height: '78vh' }}>
                <MapContainer
                  center={coordinates[0]}
                  zoom={6}
                  style={{ height: "100%", width: "100%" }}
                  >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    />

                  {/* Add markers for all waypoints */}
                  {coordinates.map((pos, index) => (
                    <Marker
                      key={index}
                      position={pos}
                      icon={
                        index === 0
                        ? startIcon
                          : index === coordinates.length - 1
                          ? endIcon
                          : defaultIcon
                        }
                    >
                      <Popup>Waypoint {index + 1}</Popup>
                    </Marker>
                  ))}
                  <RoutingMachine waypoints={coordinates} />
                </MapContainer>
              </div>
            </div>
            <div className='h-[calc(100vh-10rem)] overflow-hidden'>
              {halt.length !== 0 &&  halt.map((item, index) => (
                <div key={index} className='flex flex-col gap-2'>
                  <div className='flex gap-2'>
                    <span className='font-semibold'>Time:</span>
                    <span>{item?.halt_time} Minute</span>
                  </div>
                  <div className='flex gap-2'>
                    <span className='font-semibold'>Location:</span>
                    <span>{item?.place_name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {paymentRequestToggle && <PaymentRequest />}
      </div>
    </>
  );
}

export default Index;